var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96.062 54.728a32.062 32.062 0 1 0 -54.71 22.685 30.736 30.736 0 0 1 9.266 21.707v.82h26.764v-.823a29.586 29.586 0 0 1 8.88-21.326 31.947 31.947 0 0 0 9.8-23.063z",
    fill: "#fbd62e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.851 53.169a1.751 1.751 0 0 1 -1.735-1.529 24.176 24.176 0 0 0 -1.1-4.756 1.75 1.75 0 0 1 3.312-1.132 27.661 27.661 0 0 1 1.261 5.448 1.75 1.75 0 0 1 -1.516 1.956 1.675 1.675 0 0 1 -.222.013z",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.832 66.335a4.756 4.756 0 0 0 -4.75 4.75v1.25h-6.165v-1.25a4.75 4.75 0 1 0 -4.75 4.75h1.25v27.013a1.75 1.75 0 0 0 3.5 0v-27.013h6.165v27.013a1.75 1.75 0 1 0 3.5 0v-27.013h1.25a4.75 4.75 0 0 0 0-9.5zm-16.915 4.75a1.25 1.25 0 0 1 2.5 0v1.25h-1.25a1.252 1.252 0 0 1 -1.25-1.25zm16.915 1.25h-1.25v-1.25a1.25 1.25 0 1 1 1.25 1.25z",
    fill: "#fd9600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.618 113.375h26.764a0 0 0 0 1 0 0v2.125a6 6 0 0 1 -6 6h-14.764a6 6 0 0 1 -6-6v-2.125a0 0 0 0 1 0 0z",
    fill: "#385b60"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#537980",
    height: 6,
    rx: 3,
    width: 34.377,
    x: 46.812,
    y: 109.853
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#385b60",
    height: 6,
    rx: 3,
    width: 34.377,
    x: 46.812,
    y: 103.808
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#537980",
    height: 6,
    rx: 3,
    width: 34.377,
    x: 46.812,
    y: 97.763
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbd62e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64 16.25a1.751 1.751 0 0 1 -1.75-1.75v-8a1.75 1.75 0 0 1 3.5 0v8a1.751 1.751 0 0 1 -1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.9 21.638a1.748 1.748 0 0 1 -1.517-.876l-4-6.928a1.75 1.75 0 1 1 3.031-1.75l4 6.928a1.751 1.751 0 0 1 -1.514 2.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.176 36.355a1.74 1.74 0 0 1 -.873-.235l-6.928-4a1.75 1.75 0 1 1 1.75-3.031l6.928 4a1.751 1.751 0 0 1 -.877 3.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.791 56.459h-8a1.75 1.75 0 1 1 0-3.5h8a1.75 1.75 0 0 1 0 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.251 80.564a1.75 1.75 0 0 1 -.876-3.266l6.928-4a1.75 1.75 0 0 1 1.75 3.031l-6.928 4a1.747 1.747 0 0 1 -.874.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.1 21.638a1.751 1.751 0 0 1 -1.514-2.626l4-6.928a1.75 1.75 0 1 1 3.031 1.75l-4 6.928a1.748 1.748 0 0 1 -1.517.876z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.824 36.355a1.751 1.751 0 0 1 -.877-3.266l6.928-4a1.75 1.75 0 1 1 1.75 3.031l-6.928 4a1.74 1.74 0 0 1 -.873.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.209 56.459h-8a1.75 1.75 0 0 1 0-3.5h8a1.75 1.75 0 0 1 0 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.748 80.564a1.74 1.74 0 0 1 -.873-.235l-6.928-4a1.75 1.75 0 0 1 1.753-3.029l6.928 4a1.75 1.75 0 0 1 -.877 3.266z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.db7b65aa99f824c7c946eafe859a2591.svg";
export { ForwardRef as ReactComponent };